import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * The backdrop every dialog and sheet sits in. It renders onto document.body, never where it was
 * opened: the app shell scrolls an inner column, and the screens rise in with a transform
 * animation, which makes any `position: fixed` descendant fixed to that tall column instead of the
 * viewport. A dialog opened from far down a page then lands far above the screen. On the body the
 * backdrop's `position: fixed` (from its class) always means the viewport, centred and on top of
 * the sidebar's and the reel stage's own stacking contexts.
 */
export function Overlay({
  onClose,
  className = 'sheet-backdrop',
  children,
}: {
  /** Called on a click on the backdrop itself; leave it out where only the sheet's buttons close it. */
  onClose?: () => void;
  className?: string;
  children: ReactNode;
}) {
  return createPortal(
    <div
      className={className}
      data-overlay=""
      role="presentation"
      onClick={onClose ? (e) => e.target === e.currentTarget && onClose() : undefined}
    >
      {children}
    </div>,
    document.body,
  );
}
